import PropTypes from 'prop-types';

export const commonPropTypes = {
  /** Callback to be called when the user clicks on the card */
  onClick: PropTypes.func,
  /** Url where the user will navigate to when clicking on the card*/
  clickUrl: PropTypes.string.isRequired
};

export const commonDefaultProps = {
  onClick: () => {}
};
